/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import { Box, TextField } from "@mui/material";
import React, { useContext, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import * as Sentry from "@sentry/react";
import { AlertStatus } from "../../../contants";
import style from "./FriendSearch.styles";
import Friends from "../../../services/api/friend";
import Button from "../../../components/common/Button";
import Typography from "../../../components/common/new/Typography/Typography";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";

const REMARK = "remark";
const DEACTIVATE_REASONS = [
  {
    displayName: "Not interested in practicing",
    value: "NOT_INTERESTED_IN_PRACTICING",
  },
  {
    displayName: "Does not fulfill BSG Shakubuku Guidelines",
    value: "DOES_NOT_FULFILL_BSG_SHAKABUKU_GUIDELINES",
  },
  {
    displayName: "Passed Away",
    value: "PASSED_AWAY",
  },
  {
    displayName: "Duplicate Entry",
    value: "DUPLICATE_ENTRY",
  },
];

function FriendDeactivateModal({
  selectedFriend,
  onClose,
  // callBack,
  onSearchClick,
}) {
  console.log("Freind Data :", selectedFriend);
  const [deactivationReason, setRemark] = useState("");
  const toast = useContext(ToastAlertContext);

  const handleChange = (e) => {
    const { value } = e.target;
    setRemark(value);
  };

  const validateFormData = () => {
    if (!deactivationReason) {
      return "Please select valid reason";
    }
    return "";
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const error = validateFormData();
      if (error) {
        return toast.show(
          "Please enter Reason for Deactivation",
          AlertStatus.ERROR
        );
      }
      //   Valid form data
      const body = {
        deactivationReason,
      };

      await Friends.friendDeactivate({
        data: body,
        friendId: selectedFriend.friendId,
      });

      toast.show("Friend Deactivated Successfully", AlertStatus.SUCCESS);

      setTimeout(() => {
        onSearchClick();
        onClose();
        // callBack();
      }, 2000);
    } catch (error) {
      Sentry.captureException(error);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <div style={style.popup}>
        <Box>
          <Typography variant="title2" color="#8c8c8c">
            Reason for deactivating the Friend?
          </Typography>
        </Box>
        <Box padding="15px 0px 15px 0px">
          <TextField
            name={REMARK}
            sx={{ width: "100%" }}
            label="Select your reason for deactivation"
            select
            value={deactivationReason}
            onChange={handleChange}
            inputProps={{ required: true }}
          >
            {DEACTIVATE_REASONS.map((option) => (
              <MenuItem value={option.value}>{option.displayName}</MenuItem>
            ))}
          </TextField>
        </Box>
        {/* <Box paddingTop="15px">
          <TextField
            name={REMARK}
            sx={{ width: "100%" }}
            variant="outlined"
            label="Enter your reason for deactivation"
            style={style.inputStyle}
            value={deactivationReason}
            onChange={handleChange}
            InputProps={{ sx: { minHeight: "91px" } }}
          />
        </Box> */}
        <div style={style.buttonStyle}>
          <Button
            variant="contained"
            onClick={onSubmit}
            type="submit"
            label="Deactivate"
          />
          <Button
            style={{ marginLeft: "16px" }}
            variant="outlined"
            onClick={onClose}
            label="   cancel"
          />
        </div>
      </div>
    </form>
  );
}

export default FriendDeactivateModal;
